module.exports = __webpack_public_path__ + "img/facebook.d2113ac3.svg";